// =============================================================================
// global
// =============================================================================

// Change Company
// =============================================================================

const getCompanyValues = () => {
  const options = $('#changeCompany--js').find('a.menu-settings__link');
  const companyOptions = [];
  options.each((i,e) => {
    const ele = $(e);
    companyOptions.push({
      name: ele.text(),
      value: parseInt(ele.attr('data-value'))
    });
  });
  return companyOptions;
};

export const companyData = { 
  id: $('#changeCompany--js').find('a.menu-settings__link--active').attr('data-value') || $('#cid').val(), 
  reloadQueryString: '',
  options: getCompanyValues()
};

export default function() {
  const ele = this;
  const cid = ele.getAttribute('data-value');
  $.ajax({
    type: 'POST',
    url: '/Account/User/ChangeCompany',
    data: `cid=${cid}`,
    success(response) {
      if (response) {
        companyData.id = cid; // update selected company
        if (window.location.pathname.indexOf('Forms/ProjectReview') > -1) {
          // Clear search so it will redirect user back to MainInfo page
          window.location.search = '';
        } else {
          // trigger custom company change event so logic related to company can be handled where it matters.
          $(document).trigger('on:CompanyChange');
          
          // Reload the page if the query string wasn't updated, or set location.search
          if(companyData.reloadQueryString === '') {
            window.location.reload();
          }
          else {
            window.location.search = companyData.reloadQueryString;
          }

        }
      }
    }
  });
}